import React from 'react';
import { Box } from '@mui/joy';
import { Editor as TinyMCEEditor } from '@tinymce/tinymce-react';

interface RichTextEditorProps {
  value: string;
  onChange: (next: string) => void;
  height?: number;
  disabled?: boolean;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  height = 320,
  disabled = false,
}) => {
  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 'sm', overflow: 'hidden' }}>
      <TinyMCEEditor
        tinymceScriptSrc={'/tinymce/tinymce.min.js'}
        licenseKey={'gpl'}
        value={value}
        disabled={disabled}
        onEditorChange={(content: string) => onChange(content || '')}
        init={{
          height,
          menubar: false,
          plugins: ['link', 'lists', 'table', 'code'],
          toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | link table | code',
          base_url: '/tinymce',
          suffix: '.min',
          valid_elements: '*[*]',
          entity_encoding: 'raw',
          verify_html: false,
          convert_urls: false,
          remove_script_host: false,
          relative_urls: false,
          branding: false,
        }}
      />
    </Box>
  );
};

export default RichTextEditor;
